import FullScreen from './FullScreen';
import classes from './Loader.module.css';


const Loader = () => {
    return (
        <FullScreen style={{minHeight: '0px'}}>
            <div className={classes.spinner}></div>
        </FullScreen>
    )
}

export default Loader;
